export function getConfig(p = {}) {

    const {config = {}} = p;

    const commonConfig = config.common || {};
    const globalsConfig = config.globals || {};

    const {WAPP, DEV} = globalsConfig;

    const common = {
        ...commonConfig,
        siteName: "FlatChooser Helpers | Test Site",
        description: "It is a test site for FlatChooser Helpers package",
        graphql: {
            route: (DEV) ? "/graphql" : "/g" + WAPP
        }
    };

    return {
        config: {
            ...config,
            common: common
        },
    }
}
